import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import { BenchmarkInsightCompetitorsCompetitor } from 'lumen/models';

export default class BenchmarkInsightCompetitorsDesiredCompetitor extends BenchmarkInsightCompetitorsCompetitor {
  // @ts-expect-error: Class inheritance
  [Type] = 'benchmark-insight/competitors/desired-competitor' as const;

  @attr('boolean') declare compsetAvailable: boolean;
  @attr('boolean') declare compsetReady: boolean;
}
